import { render, staticRenderFns } from "./complex-menu-edit-modal.vue?vue&type=template&id=46b43dc2&scoped=true&"
import script from "./complex-menu-edit-modal.vue?vue&type=script&lang=ts&"
export * from "./complex-menu-edit-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b43dc2",
  null
  
)

export default component.exports